export default __webpack_public_path__ + "static/media/Ai.38d51f38.png";